/*
 * Generated on 3/16/2022, 2:41:59 PM
 * Do not edit this file, any changes will be overwritten
 */

"use strict";

function openPopup(pUrl, pWidth, pHeight) {
  if (!pWidth) pWidth = 800;
  if (!pHeight) pHeight = 600;
  var sWidth = screen.availWidth;
  var sHeight = screen.availHeight;
  var pTop = sHeight / 2 - pHeight / 2;
  var pLeft = sWidth / 2 - pWidth / 2;
  window.open(pUrl, 'popup', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes' + ',width=' + pWidth + ',height=' + pHeight + ',top=' + pTop + ',left=' + pLeft);
}

function checkSidebarHeight() {
  $('.sidebar').each(function () {
    var sidebarHeight = $(this).outerHeight(true);
    var windowHeight = $(window).height();
    windowHeight -= $('.navbar-fixed-top').outerHeight();

    if (sidebarHeight > windowHeight) {
      $(this).addClass('no-affix');
    } else {
      $(this).removeClass('no-affix');
    }
  });
} // function setGrayGlassHeight(perc) {
//     // if (parseInt($('.progress-glass-bar-gray').height()) == perc) {
//     //     return;
//     // }
//
//     $('.progress-glass-bar-1').show().animate({'height': perc + '%'}, 500, function() {
//         if (perc == 0) {
//             // $(this).fadeOut('fast');
//         }
//     });
// }
// function setGlassHeight(perc) {
//     // if (parseInt($('.progress-glass-bar').height()) == perc) {
//     //     return;
//     // }
//
//     $('.progress-glass-bar-2').show().animate({'height': perc + '%'}, 500, function() {
//         if (perc == 0) {
//             // $(this).fadeOut('fast');
//         }
//     });
// }


function scrollTo($element, offset, duration) {
  if ($element.length === 0) return;

  if (duration === undefined) {
    duration = 1000;
  }

  $([document.documentElement, document.body]).animate({
    scrollTop: $element.offset().top + (offset === undefined ? 0 : parseInt(offset))
  }, duration);
}

var Menu = function () {
  var currentScrollTop = 0;
  $(document).ready(function () {
    var scrollBarWidth = getScrollbarWidth(); // Collapse menu

    $('.navbar-custom-collapse').on('show.bs.collapse', function (e) {
      $('.navbar-search').collapse('hide');
      $('.navbar-toggle').addClass('active'); // Het menu kan hoger zijn dan het scherm. In dat geval de huidige
      // scrolltop opslaan en de body overflow hidden geven.

      setScrollTop();
      setTimeout(function () {
        $('body').addClass('scroll-disabled');
        $('.navbar-fixed-top').css('margin-right', scrollBarWidth);
      }, 300);
    });
    $('.navbar-custom-collapse').on('hide.bs.collapse', function (e) {
      $('.navbar-toggle').removeClass('active'); // Bij het sluiten van het menu de body weer overflow scroll geven
      // en de opgeslagen scrolltop laden.

      $('body').removeClass('scroll-disabled');
      $('.navbar-fixed-top').css('margin-right', 0);
      window.scrollTop = currentScrollTop;
    }); // Collapse search

    $('.navbar-search').on('show.bs.collapse', function () {
      $('.navbar-custom-collapse').collapse('hide');
      $('.navbar-search-toggle').addClass('active');
      setTimeout(function () {
        $('.navbar-search .form-control').focus();
      }, 500);
    });
    $('.navbar-search').on('hide.bs.collapse', function () {
      $('.navbar-search-toggle').removeClass('active');
      $('body').removeClass('scroll-disabled');
      window.scrollTop = currentScrollTop;
    }); // Popin dropdown menus

    $('a[data-target-popin-menu]').on('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      var showContainer = $(this).data('target-popin-menu');
      $('.nav-popin-menu').not(showContainer).removeClass('active');

      if ($(showContainer).hasClass('active')) {
        $(showContainer).removeClass('active');
      } else {
        $(showContainer).addClass('active');
        $(window).trigger('resize-popin-menu');
      }
    });
    $(document).on('click', function () {
      $('.nav-popin-menu').removeClass('active');
    });
    $('.nav-popin-menu').on('click', function (e) {
      e.stopPropagation();
    });
    $(window).on('resize resize-popin-menu', function () {
      $('a[data-target-popin-menu]').each(function () {
        var $target = $($(this).data('target-popin-menu'));

        if (!$target.hasClass('active')) {
          return;
        } // var left = $(this).position().left;
        //
        // if ($target.hasClass('message-flags')) {
        //     // quickfix voor presentatie
        //     left -= 140;
        // }
        //
        // $target.css({
        //     top: $(this).position().top + $(this).height(),
        //     left: left
        // });

      });
    });
  });
  $(document).on('keyup', function (e) {
    if (e.keyCode == 27) {
      $('.navbar-top .icon-button[data-toggle="collapse"].active').trigger('click');
    }
  });

  var setScrollTop = function setScrollTop() {
    currentScrollTop = window.scrollTop;
  };

  var getScrollbarWidth = function getScrollbarWidth() {
    var $div = $('<div />').css({
      width: '100px',
      height: '100px',
      overflow: 'scroll',
      position: 'absolute',
      top: '-9999px'
    }).appendTo($('body'));
    var scrollbarWidth = $div.get(0).offsetWidth - $div.get(0).clientWidth;
    $div.remove();
    return scrollbarWidth;
  };
}();

$(function () {
  checkCustomInputs();
  $('[data-background], img[data-src]').imageLoader();
  $('.navbar-collapse a').on('click', function () {
    $('.navbar-toggle.active').trigger('click');
  });
  $('a.popup').on('click', function (e) {
    e.preventDefault();
    openPopup($(this).attr('href'), $(this).data('popup-width'), $(this).data('popup-height'));
  });
  $(document).on('click', 'a.confirm', function (e) {
    e.preventDefault();
    $('.confirm-popin .text').html($(this).data('confirm'));
    $('.confirm-popin .yes').attr('href', $(this).attr('href'));
    $('.confirm-popin').modal();
  });
  $(document).on('click', 'a.show-alert', function (e) {
    e.preventDefault();
    $('.alert-popin .text').html($(this).data('alert'));
    $('.alert-popin').modal();
  });
  $('input[type=number]').on('keyup', function () {
    var min = parseInt($(this).attr('min'));
    var max = parseInt($(this).attr('max'));
    var value = parseInt($(this).val());

    if (!isNaN(max) && value > max) {
      $(this).val(max);
    }

    if (!isNaN(min) && value < min) {
      $(this).val(min);
    }
  }); //    $('.modal').on('show.bs.modal', function (e) {
  //        $('.modal-backdrop').on('click', function() {
  //            console.log('click');
  //            $('.modal').modal('hide');
  //        });
  //    });

  $(window).on('resize', function () {
    checkSidebarHeight();
  }).trigger('resize');
  $('.dashboard-scores').on('click', function () {
    var targetUrl = $(this).data('scores-url');
    window.location.href = targetUrl;
  });
  /* change body background-image: append parameter ?bg=3 */

  function parseLocation(val) {
    var result = '',
        tmp = [];
    location.search.substr(1).split('&').forEach(function (item) {
      tmp = item.split('=');
      if (tmp[0] === val) result = decodeURIComponent(tmp[1]);
    });
    return result;
  }

  var bg = parseLocation('bg');
  var bgPath = ''; //var anticache = new Date().getTime();

  var anticache = '171212';

  switch (bg) {
    case '1':
      bgPath = '/site/assets/img/body-bg-2.jpg?' + anticache;
      document.styleSheets[0].addRule('body:before', 'background-image: url("' + bgPath + '");');
      break;

    case '2':
      bgPath = '/site/assets/img/body-bg-3.jpg?' + anticache;
      document.styleSheets[0].addRule('body:before', 'background-image: url("' + bgPath + '");');
      break;

    case '3':
      bgPath = '/site/assets/img/body-bg-4.jpg?' + anticache;
      document.styleSheets[0].addRule('body:before', 'background-image: url("' + bgPath + '");');
      break;

    case '4':
      bgPath = '/site/assets/img/body-bg-5.jpg?' + anticache;
      document.styleSheets[0].addRule('body:before', 'background-image: url("' + bgPath + '");');
      break;

    case '5':
      bgPath = '/site/assets/img/body-bg-6.jpg?' + anticache;
      document.styleSheets[0].addRule('body:before', 'background-image: url("' + bgPath + '");');
      break;

    case '6':
      bgPath = '/site/assets/img/body-bg-7.jpg?' + anticache;
      document.styleSheets[0].addRule('body:before', 'background-image: url("' + bgPath + '");');
      break;

    case '7':
      bgPath = '/site/assets/img/body-bg-8.jpg?' + anticache;
      document.styleSheets[0].addRule('body:before', 'background-image: url("' + bgPath + '");');
      break;

    case '8':
      bgPath = '/site/assets/img/body-bg-9.jpg?' + anticache;
      document.styleSheets[0].addRule('body:before', 'background-image: url("' + bgPath + '");');
      break;
  }
  /* end change body background-image */

});
var lastScrollTop = 0;
$(window).on('scroll', function () {
  var scrollTop = $(this).scrollTop();

  if (scrollTop > 0) {
    $('body').addClass('scrolled');
  } else {
    $('body').removeClass('scrolled');
  }

  if ($('.navbar-collapse').hasClass('in')) {
    return;
  }

  if ($('.navbar-top .icon-button.active').length == 0) {
    if (scrollTop <= lastScrollTop - 20 || scrollTop < 60) {
      $('.navbar-fixed-top, .header-loggedin-as').removeClass('up');
      lastScrollTop = scrollTop;
    } else if (scrollTop > lastScrollTop + 40) {
      $('.navbar-fixed-top, .header-loggedin-as').addClass('up');
      lastScrollTop = scrollTop;
    }
  }
});
$(window).on('mousewheel', function () {
  $(window).trigger('scroll');
});
setInterval(function () {
  $.get('/lib/keepalive.php');
}, 1000 * 60 * 10);
var scoreSwiper = null;

function startSwiper() {
  scoreSwiper = new Swiper('.scores-container', {
    // grabCursor: false,
    loop: false,
    swipeHandler: '.swiper-header',
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    preloadImages: false,
    initialSlide: typeof initialSlide !== "undefined" ? initialSlide : 0,
    threshold: 30,
    onSlideChangeStart: function onSlideChangeStart() {},
    onSlideChangeEnd: function onSlideChangeEnd() {
      var menuItem = $('.scores-container .swiper-slide-active').attr('data-menu-toggle');
      $('.score-button').removeClass('active');
      $('.score-button[data-menu-button=' + menuItem + ']').addClass('active');
    }
  }); // if (scoreSwiper.slideTo) {
  // 	scoreSwiper.slideTo(0);
  // }
}

$(function () {
  $(window).on('resize', function () {
    if (window.innerWidth < 768) {
      if (scoreSwiper !== null && typeof scoreSwiper.destroy == 'function') {
        scoreSwiper.destroy(true, true);
        scoreSwiper = null;
      }
    } else {
      if (scoreSwiper == null) {
        $('.scores-content').show();
        $('.scores-item .scores-content').removeAttr('style');
        $('.scores-item .scores-button').removeClass('active').removeClass('closed');
        startSwiper();
      }
    }
  }).trigger('resize');
  $('.score-link').on('click', function (e) {
    e.preventDefault();

    if (window.innerWidth < 768) {
      var $rewards = $('#rewards');
      $rewards.slideDown();
      scrollTo($rewards);
    }
  });
  $('.scores-menu-top .score-button').on('click', function (e) {
    e.preventDefault();
    var menuData = $(this).attr('data-menu-button');
    $('.score-button').removeClass('active');
    $(this).addClass('active');
    var slide = $('.swiper-slide[data-menu-toggle=' + menuData + ']');

    if (scoreSwiper !== null) {
      scoreSwiper.slideTo(slide.index());
    }
  });
  $('.scores-item .score-button').on('click', function (e) {
    e.preventDefault();
    var $scoresItem = $(this).closest('.scores-item');
    var $otherScoreItems = $('.scores-item').not($scoresItem).not('.dashboard, .rewards');
    $otherScoreItems.find('.scores-content').slideUp();
    $otherScoreItems.find('.score-button').removeClass('active');
    $(this).toggleClass('active');

    if ($(this).hasClass('active')) {
      $scoresItem.find('.scores-content').slideDown();
    } else {
      $scoresItem.find('.scores-content').slideUp();
    }
  });
  $('a.score-link').on('click', function (e) {
    // e.preventDefault();
    var menuData = $(this).attr('data-menu-button');
    $('.score-button').removeClass('active');
    var slide = $('.swiper-slide[data-menu-toggle=' + menuData + ']');

    if (scoreSwiper !== null) {
      scoreSwiper.slideTo(slide.index());
    }
  });
  $('.kpi-quarter-warning').on('click', function (e) {
    e.preventDefault();
    $('.kpi-warning').html($(this).data('warning')).slideDown();
  });
});

function showTotalScores(type) {
  // $('.scores-totals').not('.' + type).fadeOut('fast', function() {
  // 	$('.scores-totals.' + type).fadeIn('fast');
  setTimeout(function () {
    var swiper = prizeSwipers[type];

    if (!swiper) {}

    swiper.update();
    swiper.slideTo($('.scores-totals.' + type + ' .swiper-slide-active').index(), 0);
  }, 10); // });
}

function setCurrentPrize() {
  $('.scores-totals').each(function () {
    var type = $(this).data('type');
    var swiper = prizeSwipers[type];
    var newScore = $(this).find('.counter').data('counter-end') || -1;
    var includeScores = [];
    $(this).find('.score-prize').each(function () {
      var score = parseInt($(this).data('score'));

      if (newScore >= score) {
        includeScores.push(score);
      }
    });
    maxIncludeScore = Math.max.apply(Math, includeScores);
    $newSlide = $(this).find('.score-prize[data-score="' + maxIncludeScore + '"]:first');

    if ($newSlide.length > 0) {
      swiper.slideTo($newSlide.index(), 700);
    } // Rewards slide


    $('.progress-level').removeClass('active-' + type).filter('[data-score="' + maxIncludeScore + '"]').addClass('active-' + type);
  });
}

var ScoreMonitor = function ScoreMonitor(options) {
  var self = this;
  this.options = $.extend({
    charts: {}
  }, options);
  this.loadScoresReq = {};
  this.saveForecastReq = {};
};

ScoreMonitor.prototype.loadScores = function () {
  if (typeof this.loadScoresReq.abort == 'function') {
    this.loadScoresReq.abort();
  }

  this.loadScoresReq = $.get('/site/ajax/get_kpi_scores.php', function (data) {
    $.each(data.kpi_groups, function (kpi_nr, kpi_data) {
      var $menu_item = $('.score-button[data-menu-button="kpi_' + kpi_nr + '"]');
      $menu_item.find('.progress-result').css('width', kpi_data.totals.result.score_perc + '%');
      $menu_item.find('.progress-forecast').css('width', kpi_data.totals.forecast.score_perc + '%');
      $.each(kpi_data.warnings, function (type, type_warnings) {
        var $warnings = $('.kpi-warning[data-type="' + type + '"][data-kpi="' + kpi_nr + '"]');

        if (type_warnings.length > 0) {
          $warnings.html('');
          $.each(type_warnings, function (warning_key, type_warning) {
            $warnings.append(type_warning + '<br />');
          });
          $warnings.slideDown('fast');
        } else {
          $warnings.slideUp('fast');
        }
      });
      $menu_item.find('.counter-kpi-forecast').counter({
        start: parseFloat($menu_item.find('.counter-kpi-forecast').data('counter-current')),
        end: kpi_data.totals.forecast.score,
        duration: 500,
        decimals: 0
      });
      $menu_item.find('.counter-kpi-result').counter({
        start: parseFloat($menu_item.find('.counter-kpi-result').data('counter-current')),
        end: kpi_data.totals.result.score,
        duration: 500,
        decimals: 0
      });
      var $counterResult = $('.counter-kpi-' + kpi_nr + '-result');
      var $counterForecast = $('.counter-kpi-' + kpi_nr + '-forecast');
      $counterResult.counter({
        start: parseFloat($counterResult.data('counter-current')),
        end: kpi_data.totals.result.score,
        duration: 500,
        decimals: 0
      });
      $counterForecast.counter({
        start: parseFloat($counterForecast.data('counter-current')),
        end: kpi_data.totals.forecast.score,
        duration: 500,
        decimals: 0
      });
    });
    $.each(data.kpi_subgroups, function (subgroup_name, subgroup_data) {
      var $counterResult = $('.counter-kpi-' + subgroup_name + '-result');
      var $counterForecast = $('.counter-kpi-' + subgroup_name + '-forecast');
      $counterResult.counter({
        start: parseFloat($counterResult.data('counter-current')),
        end: subgroup_data.totals.result.score,
        duration: 500,
        decimals: 0
      });
      $counterForecast.counter({
        start: parseFloat($counterForecast.data('counter-current')),
        end: subgroup_data.totals.forecast.score,
        duration: 500,
        decimals: 0
      });
    });
    $('.counter-result').data('counter-end', data.totals.result.score).counter({
      start: parseFloat($('.counter-result').data('counter-current')),
      end: data.totals.result.score,
      duration: 500,
      decimals: 0
    });
    $('.counter-forecast').data('counter-end', data.totals.forecast.score).counter({
      start: parseFloat($('.counter-forecast').data('counter-current')),
      end: data.totals.forecast.score,
      duration: 500,
      decimals: 0
    });
    setGrayGlassHeight(data.totals.forecast.score_perc);
    setGlassHeight(data.totals.result.score_perc);
    setCurrentPrize(); // $('.progress-levels .progress-level').each(function() {
    // 	if ($(this).data('score') <= data.totals.forecast.score) {
    // 		$(this).addClass('active-forecast');
    // 	} else {
    // 		$(this).removeClass('active-forecast');
    // 	}
    //
    // 	if ($(this).data('score') <= data.totals.result.score) {
    // 		$(this).addClass('active-result');
    // 	} else {
    // 		$(this).removeClass('active-result');
    // 	}
    // });
  });
};

ScoreMonitor.prototype.saveForecast = function (kpi_key, value) {
  var self = this;

  if (typeof this.saveForecastReq.abort == 'function') {
    this.saveForecastReq.abort();
  }

  this.saveForecastReq = $.post('/site/ajax/save_kpi_forecast.php', {
    kpi_key: kpi_key,
    value: value
  }, function () {
    self.loadScores();
    showTotalScores('forecast');
  });
};